import React, { useEffect, useState } from 'react';
import { Moon, Flame } from 'lucide-react';
export function OfferBar() {
  const [timeLeft, setTimeLeft] = useState(15 * 60); // 15 minutes in seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 0) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins < 10 ? '0' : ''}${mins}:${secs < 10 ? '0' : ''}${secs}`;
  };
  const isUrgent = timeLeft < 300; // Under 5 mins
  const isCritical = timeLeft < 60; // Under 1 min
  return <div className={`fixed top-0 left-0 w-full z-50 transition-colors duration-500 ${isUrgent ? 'bg-brand-dark/95 border-b-red-900/50' : 'bg-brand-dark/90'} backdrop-blur-md text-white h-11 flex items-center justify-center border-b border-brand-indigo/30 shadow-lg`} data-id="element-246">
      <div className="flex items-center gap-2 text-xs sm:text-sm font-medium px-4" data-id="element-247">
        {isUrgent ? <Flame className="text-red-400 w-4 h-4 animate-bounce" data-id="element-248" /> : <Moon className="text-brand-indigo w-4 h-4" data-id="element-249" />}
        <span className={isCritical ? 'animate-flash-urgent' : ''} data-id="element-250">
          {timeLeft < 120 && <span className="text-red-400 font-bold mr-1" data-id="element-251">
              ¡ÚLTIMOS MINUTOS!
            </span>}
          Tu descanso empieza hoy. Oferta expira en:
          <span className={`font-bold ml-1 tabular-nums tracking-wider ${isCritical ? 'text-red-400' : 'text-brand-amber'}`} data-id="element-252">
            {formatTime(timeLeft)}
          </span>
        </span>
      </div>
    </div>;
}